export const api_url = process.env.REACT_APP_API_HTTP_URL;
export const ws_url = process.env.REACT_APP_API_WS_URL;
export const google_auth_client_id = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
export const whitelist = [
  "fxtryio@gmail.com",
  "khalid.ia97@gmail.com",
  "sapu.um01@gmail.com",
  "lukmanrahman98@gmail.com",
  "emporiumflow@gmail.com",
];
